<template>
  <div>
    <div class="container">
      <div class="title">账号设置>修改密码</div>
      <div class="bottom">
        
    <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    >
    <a-form-model-item ref="oldmm" label="请输入当前密码" prop="oldmm">
      <a-input
        v-model="form.oldmm"
        type="password"
        :maxLength="20"
      />
    </a-form-model-item>
    <a-form-model-item ref="newMM" label="请输入新密码" prop="newMM">
      <a-input
        v-model="form.newMM"
        type="password"
        :maxLength="20"
      />
    </a-form-model-item>
    <a-form-model-item ref="QnewMM" label="确认新密码" prop="QnewMM">
      <a-input
        v-model="form.QnewMM"
        type="password"
        :maxLength="20"
      />
    </a-form-model-item>
    </a-form-model>

      <div class="btns">
        <button class="qued" @click="updatePassword('ruleForm')">确定</button>
        <button class="qux" @click="$router.back()">取消</button>
      </div>
        
      </div>
    </div>
  </div>
</template>


<script>
import {encryptedData} from '../../../../../common/utils/Encryption/JSEncrypt'
export default {
  data(){
    
    //自定义两次输入密码的校验规则
    let MM = (rule, value, callback) => {
      if (value !== this.form.newMM) {
        callback(new Error('两次密码输入不一致'));
      } 
      callback()
    };
    let validatemm = (rule, value, callback) => {
      var reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    return{
       labelCol: { span: 8 },
      wrapperCol: { span: 14 },

       form:{
        oldmm:'',
        newMM:'',
        QnewMM:'',
      },

      //校验规则
       rules: {
        oldmm: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
        ],
         newMM: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, max: 16, message: '密码长度应在8-16位', trigger: 'blur' },
          { validator: validatemm,message: '密码需要为数字，字母，特殊字符的组合', trigger: 'blur' },
        ], 
         QnewMM: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: MM,message:'两次密码输入不一致', trigger: 'blur' }
        ],
      },
     

      
    }
  },

  created(){
  },

  methods:{
    //点击修改了密码
    updatePassword(ruleForm){
      this.$refs[ruleForm].validate(v=>{
        if(!v) return this.$message.warning('请输入正确的密码')
      this.post({
        url:'updatePassword',
        data:{
          newPassword:this.form.newMM,
          oldPassword:encryptedData(this.form.oldmm)
        }
        },(res)=>{
          console.log(res);
          if(res.code===200){
            this.$message.success('修改密码成功')
          }else{
            this.$message.error('您输入的密码不正确')
          }
        })
      })
    },
    
  }
}
</script>


<style scoped>
.container{
  width: 100%;
  height: 320px;
  background-color: #fff;
  margin: 20px auto;
}

.title{
  height: 40px;
  border-bottom: 1px solid #DFE7EA;
  background: #ffffff;
  padding-left: 44px;
  line-height: 40px;
  position: relative;
}




.txt{
    width: 460px;
    height: 40px;
    background: #CBEFFF;
    margin-bottom: 20px;
    border-left: 2px solid #169CDB;
    border-top: 2px solid #DFE7EA;
    border-bottom: 2px solid #DFE7EA;
    border-right: 2px solid #DFE7EA;
    font-size: 20px;
    line-height: 40px;
}

.btns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
}

.qued{
  background: #F06B42;
  color: #ffffff;
  border: 0;
}

.qux{
  background: #F0F8FB;
  color: #86878B;
  border: 1px solid #86878B;
}

.btns button{
  width: 111px;
  height: 43px;
  border-radius: 5px;
  font-size: 20px;
  margin-left: 20px;
}


.bottom{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}



/deep/ .ant-form{
  margin-top: 30px;
  margin-bottom: 20px;
}

/deep/ .ant-input{
  width: 460px;
  height: 40px;
  color: #C5C5C5;
  background: #CBEFFF;
  border-left: 2px solid #169CDB;
  border-top: 2px solid #DFE7EA;
  border-bottom: 2px solid #DFE7EA;
  border-right: 2px solid #DFE7EA;
}

/deep/ .ant-form-item label {
    position: relative;
    left: -60px;
}

/deep/ .ant-form-item{
  margin-left: -160px;
}
</style>


// WEBPACK FOOTER //
// src/views/grzx/pages/xgmm.vue